
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/senior-adjacent-industries",
      function () {
        return require("private-next-pages/partners/senior-adjacent-industries/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/senior-adjacent-industries"])
      });
    }
  